module.exports = __webpack_public_path__ + "img/ic_handset@2x.5485019d.jpg";